import config from "@config/config";
import ApiService from "./api";

class ResourceApi extends ApiService {
  constructor() {
    if (ResourceApi.instance) {
      return ResourceApi.instance;
    }

    super(config.resourceApiUrl);
    ResourceApi.instance = this;
  }

  async uploadFile(accountId, formData) {
    const response = await this.http.post(
      `/accounts/${accountId}/upload`,
      formData,
    );
    return response.data;
  }

  async removeFile(accountId, formData) {
    const response = await this.http.delete(
      `/accounts/${accountId}/removeFile`,
      {
        data: formData,
      },
    );
    return response.data;
  }

  async createResource(accountId, data) {
    const response = await this.http.post(
      `/accounts/${accountId}/resources`,
      data,
    );
    return response.data;
  }

  async getResourcesByEntity(
    accountId,
    entityId,
    entityType,
    isGlobal = false,
  ) {
    const response = await this.http.get(
      `/accounts/${accountId}/resources?entityId=${entityId}&entityType=${entityType}&isGlobal=${isGlobal}`,
    );
    return response.data;
  }

  async deleteResource(accountId, resourceId) {
    const response = await this.http.delete(
      `/accounts/${accountId}/resources/${resourceId}`,
    );
    return response.data;
  }

  async deleteResourceByIds(accountId, resourceIds, isJournal = false, isProcess = false) {
    const query = isProcess ? `isProcess=true` : `isJournal=${isJournal}`;
    const response = await this.http.delete(
      `/accounts/${accountId}/resourcesIds/${resourceIds}?${query}`,
    );
    return response.data;
  }
}

const resourceApiInstance = new ResourceApi();
export default resourceApiInstance;
